module.exports = {
  message: {
    service_desc: 'Use the utility to swap COS between different formats including <strong>native COS, and ERC-20.</strong>',
    choose_token_type: 'Choose your cos format',
    fee_tips: 'If the number of swap is greater than 500, 50 cos will be charged as a handling fee \' +\n' +
      '        \'If it is less than 500, 10% of the swap amount will be charged as a handling fee.',
    token_type_erc20_to_bep2: 'ERC-20 to BEP2',
    token_type_erc20_to_native: 'ERC-20 to native COS',
    token_type_bep2_to_erc20: 'BEP2 to ERC-20',
    token_type_bep2_to_native: 'BEP2 to native COS',
    token_type_native_to_erc20: 'native COS to ERC-20',
    token_type_native_to_bep2: 'native COS to BEP2',
    enter_address: 'Enter your address or account',
    enter_exchange_memo: 'Enter your Exchange memo',
    create_account_tips: 'Don\'t have an account? Create one',
    next_btn: 'NEXT',
    start_over_btn: 'Start over',
    ready_to_swap: 'Ready to swap',
    transfer_prefix: 'Transfer your {token} to',
    address: 'Address',
    memo: 'Memo',
    auto_swap_desc: 'Make sure you enter the ADDRESS and MEMO correctly.Swap token utility will send out the corresponding amount of COS token below wallet once receiving your token.<strong>The process may take about 5-30 minutes<strong>.',
    main_net_address: 'COS MainNet Address',
    bep2_address: 'BEP2 Address',
    erc20_address: 'ERC-20 Address',
    main_net_token: 'COS MainNet',
    bep2_token: 'COS-BEP2',
    erc20_token: 'COS-ERC20',
    ok: 'Okay',
    Cancel: 'Cancel',
    tips: 'Tips',
    enter_address_tips: 'Preencha o endereço do token correto primeiro',
    enter_exChange_memo_tips: 'Please fill in the exchange memo',
    swap_address_invalid: 'swap address is invalid',
    swap_address_not_exit: 'Account does not exist',
    swap_type_invalid: 'invalid swap type',
    swap_system_error: 'System error occurred. Please try again later.',
    swap_unknown_error: 'Unknown error occurred. Please try again later.',
    swap_memo_invalid: 'Invalid Memo',
    invalid_bnb_exChange_memo_tips: 'Binance exchange memo should be a number',
    paste_warning: 'Ao colar o endereço em uma exchange, verifique se ele é idêntico ao exibido acima.',
    fee_notice: 'Aviso: Uma taxa de serviço de {fee} COS será deduzida de cada conversão para cobrir as taxas de gas das transferências de {token}. Solicitações de conversão inferiores a {fee} COS não serão processadas.',
    fee_subject_to_change: 'A taxa de serviço está sujeita a alterações sem aviso prévio',
    view_status: 'Ver status da conversão',
    prev_step: 'Voltar',
    go_back: 'Voltar',
    bep20_address: 'Endereço BEP-20',
    bep20_token: 'BEP-20 COS',
    token_type_bep20_to_native: 'BEP-20 => COS Nativo MainNet',
    token_type_native_to_bep20: 'COS Nativo MainNet => BEP-20',
    transfer_prefix_before: 'Transfira seus',
    transfer_prefix_after: 'para',
    copy_memo: 'Copiar MEMO',
    copy_address: 'Copiar endereço',
    copy_success: 'Copiado',
    memo_warning: 'Importante: Ao transferir, anexe o MEMO correto. O sistema converterá o valor efetivamente depositado e enviará de volta ao endereço informado. Não omita o MEMO.',
    col_time: 'Horário',
    col_target_format: 'Formato destino',
    col_target_account: 'Conta destino',
    col_amount: 'Valor depositado',
    col_status: 'Status',
    loading: 'Carregando\u2026',
    no_data: 'Nenhum dado',
    next_update_hint: 'Os dados serão atualizados em {time}',
    status_done: 'Concluído',
    status_pending: 'Processando',
    panel_title_status: 'Status da Conversão',
    panel_title_step1: 'Ferramenta de Conversão de Tokens',
    panel_title_step2: 'Pronto para Converter Tokens',
    panel_subtitle_status: 'Selecione o formato do token de origem para verificar os registros de conversão',
    source_network: 'Formato do token de origem',
    conversion_record: 'Registro de Conversão',
    new_label: 'Novo'
  }
}
